import { render, staticRenderFns } from "./MultipleListTextAnswer.vue?vue&type=template&id=f7c9b9d0&scoped=true&"
import script from "./MultipleListTextAnswer.vue?vue&type=script&lang=js&"
export * from "./MultipleListTextAnswer.vue?vue&type=script&lang=js&"
import style0 from "./MultipleListTextAnswer.vue?vue&type=style&index=0&id=f7c9b9d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c9b9d0",
  null
  
)

export default component.exports